<template>
  <div class="app-container">
    <div class="content w-1200">
      <el-menu :default-active="activeName" background-color="#F5F5F5" mode="horizontal" @select="handleClick">
        <el-menu-item index="1">基本资料</el-menu-item>
        <el-menu-item index="2">交易信息</el-menu-item>
        <el-menu-item index="3">修改密码</el-menu-item>
      </el-menu>
      <div class="body">
        <div class="user-info" v-if="activeName == '1'">
          <div class="user-title" v-if="Number(userInfo.is_check) !== 1">
            审核状态：
            <el-tag type="warning" v-if="Number(userInfo.is_check) === 0">审核中</el-tag>
            <el-tag type="success" v-else-if="Number(userInfo.is_check) === 1">审核通过</el-tag>
            <el-tag type="warning" v-else-if="Number(userInfo.is_check) === 2">请完善资料，提交审核</el-tag>
            <span v-else>
              <el-tag type="danger">审核失败 : {{ userInfo.remarks }}</el-tag>
            </span>
          </div>
          <!--        -->
          <el-form ref="formRules" :model="userform" :rules="formRules" label-width="100px"
                   v-if="userInfo.is_check != 1"
          >
            <el-row>
              <el-form-item label="头像" prop="license">
                <ImageUpload :maxCount="1" v-model="userform.avatar" @change="handleAvatar"
                             :value="userform.avatar"/>
              </el-form-item>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="手机号" prop="nickname">
                  <div class="flex-b gap-10">
                    <div class="model-mobile">{{ userInfo.mobile }}</div>
                    <gradient-button v-if="!userInfo.unionid" @hit="bindWechat" background="#0C60E6">绑定微信
                    </gradient-button>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="2">
                <el-form-item label="昵称" prop="nickname">
                  <el-input v-model="userform.nickname"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="邮箱" prop="email">
                  <el-input v-model="userform.email"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="2">
                <el-form-item label="姓名" prop="realname">
                  <el-input v-model="userform.realname"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="身份" prop="role">
                  <el-radio-group v-model="userform.role">
                    <el-radio :label="1">贸易商</el-radio>
                    <el-radio :label="2">工厂</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="2">
                <el-form-item label="纳税人性质" prop="tax_type">
                  <el-radio-group v-model="userform.tax_type">
                    <el-radio :label="1">一般纳税人</el-radio>
                    <el-radio :label="2">小规模</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="所在地区" prop="district">
                  <el-cascader v-model="userform.district" :options="areaOptions" :props="{ expandTrigger: 'hover' }"
                               :style="{ width: '100%' }"></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="2">
                <el-form-item label="企业名称" prop="company">
                  <el-input v-model="userform.company"></el-input>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="组织机构代码" prop="company_code">
                  <el-input v-model="userform.company_code"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="营业执照" prop="license">
                <ImageUpload :maxCount="1" v-model="userform.license" @change="handleLicense"
                             :value="userform.license"/>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="危化证">
                <ImageUpload :maxCount="5" v-model="userform.danger_image" @change="handleDangerImage"
                             :value="userform.danger_image"/>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="其他资料">
                <ImageUpload :maxCount="9" v-model="userform.other" @change="handleOther" :value="userform.other"/>
              </el-form-item>
            </el-row>
            <el-row>
              <!--             -->
              <el-col :span="2" :offset="22" v-if="userInfo.is_check != 1">
                <gradient-button background="#0C60E6" @hit="handleSubmit">保存更改
                </gradient-button>
              </el-col>
            </el-row>
          </el-form>
          <div v-else>
            <!--         -->
            <el-descriptions title="基本资料" :column="2" border size="middle">
              <el-descriptions-item label="手机号">{{ userInfo.mobile || '-' }}</el-descriptions-item>
              <el-descriptions-item label="姓名">{{ userInfo.realname }}</el-descriptions-item>
              <el-descriptions-item label="企业名称">{{ userInfo.company }}</el-descriptions-item>
              <el-descriptions-item label="营业执照">
                <template v-if="normalizeFiles(userInfo.license).length">
                  <img v-for="(img, i) in normalizeFiles(userInfo.license)" :key="i" :src="img" @click="lookImage(img)"
                       style="height:60px;margin-right:8px;"/>
                </template>
                <template v-else>-</template>
              </el-descriptions-item>
              <el-descriptions-item label="危化证">
                <template v-if="normalizeFiles(userInfo.danger_image).length">
                  <img v-for="(img, i) in normalizeFiles(userInfo.danger_image)" :key="i" :src="img"
                       style="height:60px;margin-right:8px;" @click="lookImage(img)"/>
                </template>
                <template v-else>-</template>
              </el-descriptions-item>
              <!--              <el-descriptions-item label="联系客服修改基本资料">-->
              <!--                <div v-if="customerService">-->
              <!--                  客服姓名： {{ customerService.username }}-->
              <!--                </div>-->
              <!--                <div v-if="customerService">-->
              <!--                  联系方式：{{ customerService.mobile }}-->
              <!--                  <span class="color-blue" @click="copyText(customerService.mobile)">-->
              <!--                  <i class="el-icon-copy-document"></i>-->
              <!--                </span>-->
              <!--                </div>-->
              <!--              </el-descriptions-item>-->
            </el-descriptions>

            <div class="margin-top"></div>
            <el-form ref="formRules" :model="userform" :rules="formRules" label-width="100px">
              <el-row>
                <el-col :span="10">
                  <el-form-item label="头像" prop="license">
                    <ImageUpload :maxCount="1" v-model="userform.avatar" @change="handleAvatar"
                                 :value="userform.avatar"/>
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="2">
                  <el-form-item label="危化证">
                    <ImageUpload :maxCount="5" v-model="userform.danger_image" @change="handleDangerImage"
                                 :value="userform.danger_image"/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <el-form-item label="昵称" prop="email">
                    <el-input v-model="userform.nickname"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="2">
                  <el-form-item label="邮箱" prop="email">
                    <el-input v-model="userform.email"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>

                <el-col :span="10">
                  <el-form-item label="身份" prop="role">
                    <el-radio-group v-model="userform.role">
                      <el-radio :label="1">贸易商</el-radio>
                      <el-radio :label="2">工厂</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="2">
                  <el-form-item label="纳税人性质" prop="tax_type">
                    <el-radio-group v-model="userform.tax_type">
                      <el-radio :label="1">一般纳税人</el-radio>
                      <el-radio :label="2">小规模</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="10">
                  <el-form-item label="所在地区" prop="district">
                    <el-cascader v-model="userform.district" :options="areaOptions" :props="{ expandTrigger: 'hover' }"
                                 :style="{ width: '100%' }"></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="2">
                  <el-form-item label="组织机构代码" prop="company_code">
                    <el-input v-model="userform.company_code"></el-input>
                  </el-form-item>
                </el-col>

              </el-row>
              <el-row>
                <el-form-item label="其他资料">
                  <ImageUpload :maxCount="9" v-model="userform.other" @change="handleOther" :value="userform.other"/>
                </el-form-item>
              </el-row>
              <el-row>
                <el-col :span="2" :offset="22">
                  <gradient-button background="#0C60E6" @hit="handleSubmit">保存更改
                  </gradient-button>
                </el-col>
              </el-row>
            </el-form>

          </div>

        </div>
        <div class="transaction" v-if="activeName == '2'">
          <div>
            <div class="title-list">
              <span>开票信息</span>
              <gradient-button @hit="invoicingeAdd" width="160px" background="#0C60E6">添加开票信息
              </gradient-button>
            </div>
            <div class="table-box">
              <el-table :data="invoicingTable" style="width: 100%" :header-cell-style="{
                backgroundColor: '#D1E1FB',
                color: '#00112B',
              }">
                <el-table-column label="序号" type="index" width="50"/>
                <el-table-column prop="title" label="发票抬头" width="180"/>
                <el-table-column prop="tax_number" label="税号"/>
                <el-table-column prop="address" label="地址"/>
                <el-table-column prop="phone" label="电话"/>
                <el-table-column prop="bank" label="开户行"/>
                <el-table-column prop="account" label=""/>
                <el-table-column prop="email" label="接收邮箱"/>
                <el-table-column label="操作" width="100" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="text" @click="invoiceEdit(scope.row.id)" size="small">编辑
                    </el-button>
                    <el-button type="text" @click="invoiceDel(scope.row.id)" size="small">删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div>
            <div class="title-list">
              <span>地址列表</span>
              <gradient-button @hit="addressAdd" width="160px" background="#0C60E6">添加地址列表
              </gradient-button>
            </div>
            <div class="table-box">
              <el-table :data="addressList" style="width: 100%" :header-cell-style="{
                backgroundColor: '#D1E1FB',
                color: '#00112B',
              }">
                <el-table-column label="序号" type="index"/>
                <el-table-column prop="is_default" label="默认" width="50">
                  <template slot-scope="scope">
                    {{ scope.row.is_default == 1 ? "是" : "否" }}
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="收货人" width="100"/>
                <el-table-column prop="address" label="所在地区">
                  <template slot-scope="scope">
                    {{ scope.row.province }}-{{ scope.row.city }}-{{
                      scope.row.area
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="address" label="详细地址"/>
                <el-table-column prop="phone" label="联系电话"/>
                <el-table-column label="操作" width="100" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="editAddress(scope.row.id)">编辑
                    </el-button>
                    <el-button type="text" size="small" @click="addressDel(scope.row.id)">删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div>
            <div class="title-list">
              <span>收款账户</span>
              <gradient-button @hit="accountAdd" width="160px" background="#0C60E6">添加收款账户
              </gradient-button>
            </div>
            <div class="table-box">
              <el-table :data="accountList" style="width: 100%" :header-cell-style="{
                backgroundColor: '#D1E1FB',
                color: '#00112B',
              }">
                <el-table-column label="序号" type="index"/>
                <el-table-column prop="name" label="开户名"/>
                <el-table-column prop="bank" label="开户行"/>
                <el-table-column prop="account" label="银行账号"/>
                <el-table-column label="操作" width="100" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="accountEdit(scope.row.id)">编辑
                    </el-button>
                    <el-button type="text" size="small" @click="accountDel(scope.row.id)">删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <el-row class="edit-info" v-if="activeName == '3'">
          <el-col :span="12" :offset="6">
            <div class="password-card">
              <div class="title-group">
                <div class="subtitle">为保障账户安全，建议定期更换强密码
                  <el-button type="text" @click="goPass">忘记密码？</el-button>
                </div>
              </div>

              <div class="password-card__body">
                <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px"
                         v-if="userInfo.is_password" class="password-form">
                  <el-form-item label="旧密码" prop="old_password">
                    <el-input type="password" v-model="passwordForm.old_password" autocomplete="off"
                              placeholder="请输入旧密码"></el-input>
                  </el-form-item>
                  <el-form-item label="新密码" prop="password">
                    <el-input type="password" v-model="passwordForm.password" autocomplete="off" show-password
                              placeholder="至少8位，含字母与数字"></el-input>
                  </el-form-item>
                  <el-form-item label="重复密码" prop="confirm_password">
                    <el-input type="password" v-model="passwordForm.confirm_password" autocomplete="off" show-password
                              placeholder="请再次输入新密码"></el-input>
                  </el-form-item>

                  <div class="form-actions" style="padding-bottom:50px;">
                    <gradient-button background="#0C60E6" width="240px" @hit="editPasswordSubmit">保存修改
                    </gradient-button>
                  </div>
                </el-form>

                <el-form v-else :model="passwordForm" :rules="passwordNewRules" ref="passwordForm" label-width="100px"
                         class="password-form">
                  <el-form-item label="密码" prop="password">
                    <el-input type="password" v-model="passwordForm.password" autocomplete="off" show-password
                              placeholder="至少8位，含字母与数字"></el-input>
                  </el-form-item>
                  <el-form-item label="重复密码" prop="confirm_password">
                    <el-input type="password" v-model="passwordForm.confirm_password" autocomplete="off" show-password
                              placeholder="请再次输入新密码"></el-input>
                  </el-form-item>

                  <div class="form-actions" style="padding-bottom:50px;">
                    <gradient-button background="#0C60E6" width="240px" @hit="editPasswordSubmit">设置密码
                    </gradient-button>
                  </div>
                </el-form>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 添加收款账户 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               :visible.sync="accountAddDialog" width="900px" title="添加收款账户" :before-close="accountAddClose">
      <div class="add-box-account">
        <el-form ref="accountForm" :model="accountForm" :rules="accountRules" label-width="120px">
          <el-form-item label="开户名" prop="name">
            <el-input v-model="accountForm.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="开户行" prop="bank">
            <el-input v-model="accountForm.bank" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="银行账号" prop="account">
            <el-input v-model="accountForm.account" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="flex-end">
          <el-button @click="accountAddClose">取 消</el-button>
          <el-button type="primary" @click="accountAddSubmit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 添加地址列表 -->
    <add-addresss :id="addressId" :addressAddDialog="addressAddDialog" @close="addressAddCloseDialog"
                  @success="getAddress"/>
    <!-- 添加开票信息 -->
    <add-invoicing :invoicingeAddDialog="invoicingeAddDialog" @close="invoicingeAddClose" @success="getInvoice"
                   :id="invoicingId"/>

    <!-- 微信公众号弹窗 -->
    <el-dialog :close-on-press-escape="false" :modal-append-to-body="false" :close-on-click-modal="false"
               :visible.sync="centerDialogVisible" title="扫码关注微信公众号" width="400px">
      <div class="qrcode-show">
        <template v-if="!userInfo.official_openid">
          <img :src="configInfo.wechat_qrcode" alt="关注微信公众号">
          <div>
            关注服务号绑定账户, 可随时获取询价/报价最新消息
          </div>
        </template>
        <!--        -->
        <template v-if="!userInfo.unionid">
          <el-button style="width: 100%;margin-top: 10px" type="primary" @click="bindWechat">
            点击绑定微信号码
          </el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import GradientButton from "@/components/button/gradient-button.vue";
import {
  getUserAddress,
  addressDelete,
  invoiceList,
  invoiceDelete,
  accountList,
  accountAdd,
  accountUpdate,
  accountDelete,
  accountDetail,
  editInfo,
  updateUserInfonew,
  editPassword,
  getMyCustomerService
} from "@/api/modules/user";
import {getAreaOptions} from "@/api/modules/common";
import addAddresss from "@/components/addInfo/add_addresss.vue";
import addInvoicing from "@/components/addInfo/add_invoicing.vue";
import ImageUpload from "@/components/public/ImageUpload.vue";
import {bind_wechat, callback, show_bind_wechat} from "../../api";

export default {
  name: "base-info",
  components: {
    GradientButton,
    addAddresss,
    addInvoicing,
    ImageUpload,
  },
  data() {
    return {
      centerDialogVisible: false,
      invoicingeAddDialog: false,
      addressAddDialog: false,
      accountAddDialog: false,
      activeName: "1",
      userform: {
        nickname: "",
        email: "",
        realname: "",
        company: "",
        tax_type: "",
        license: [],
        other: [],
        role: "",
        district: [],
        company_code: "",
        danger_image: [],
      },
      formRules: {
        nickname: [{required: true, message: "请输入", trigger: "blur"}],
        role: [{required: true, message: "请选择身份", trigger: "change"}],
        email: [
          {required: true, message: "请输入邮箱", trigger: "blur"},
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "请输入正确的邮箱",
            trigger: "blur",
          },
        ],
        realname: [
          {required: true, message: "请输入姓名", trigger: "blur"},
          {
            pattern: /^[\u4e00-\u9fa5]{2,10}$/,
            message: "请输入2-10个汉字",
            trigger: "blur",
          },
        ],
        company: [{required: true, message: "请输入企业名称", trigger: "blur"}],
        district: [{required: true, message: "请选择所在地区", trigger: "change"}],
        license: [{required: true, message: "请上传营业执照", trigger: "change"}],
        tax_type: [{required: true, message: "请选择纳税人性质", trigger: "blur"}],
      },

      // 地址列表
      addressList: [],
      // 用户发票列表
      invoicingTable: [],

      // 收款账户表单
      accountForm: {
        name: "",
        bank: "",
        account: "",
      },
      // 收款账户表单校验
      accountRules: {
        name: [{required: true, message: "请输入开户名", trigger: "blur"}],
        bank: [{required: true, message: "请输入开户行", trigger: "blur"}],
        account: [
          {required: true, message: "请输入银行账号", trigger: "blur"},
        ],
      },
      // 收款账户列表
      accountList: [],
      passwordForm: {
        old_password: "",
        password: "",
        confirm_password: "",
      },
      passwordRules: {
        old_password: [
          {required: true, message: "请输入旧密码", trigger: "blur"},
        ],
        password: [
          {required: true, message: "请输入新密码", trigger: "blur"},
        ],
        confirm_password: [
          {required: true, message: "请输入重复密码", trigger: "blur"},
          {validator: this.checkPassword, trigger: "blur"},
        ],
      },
      passwordNewRules: {
        password: [
          {required: true, message: "请输入新密码", trigger: "blur"},
        ],
        confirm_password: [
          {required: true, message: "请输入重复密码", trigger: "blur"},
          {validator: this.checkPassword, trigger: "blur"},
        ],
      },
      imageUrl: "",
      rules: [],

      // 获取地址
      areaOptions: [],
      // 用户信息
      // 地址id
      addressId: "",
      // 开票信息id
      invoicingId: "",
      customerService: {},
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    configInfo() {
      return this.$store.state.config.config;
    },
  },
  watch: {
    userInfo: {
      handler(val) {
        this.setUserForm(val);

      },
      immediate: true
    },
  },
  created() {
    this.init();
    this.getAddress();
    this.getInvoice();
    this.getAccount();
  },
  mounted() {
    this.$store.dispatch("GET_USER_INFO").then(() => {
      if (!this.userInfo.official_openid || !this.userInfo.unionid) {
        this.centerDialogVisible = true
      }
    });
    this.setUserForm(this.userInfo);
  },
  methods: {
    lookImage(image) {
      window.open(image, '_blank')
    },
    goPass() {
      this.$router.push({path: '/agreement/findPassword'})
    },
    formatDistrict(val) {
      if (!val || !val.length) return '-'
      if (Array.isArray(val)) return val.join(' / ')
      return String(val)
    },
    normalizeFiles(val) {
      if (!val) return []
      if (Array.isArray(val)) return val
      try {
        const parsed = JSON.parse(val)
        return Array.isArray(parsed) ? parsed : [val]
      } catch (e) {
        return [val]
      }
    },
    watchFalse() {
      this.centerDialogVisible = false
    },
    setUserForm(val) {
      this.userform = {
        avatar: this.checkLicense(val.avatar),
        nickname: val.nickname,
        email: val.email,
        realname: val.realname,
        company: val.company,
        tax_type: val.tax_type,
        license: this.checkLicense(val.license),
        other: this.checkLicense(val.other),
        role: val.role,
        district: val.district,
        company_code: val.company_code,
        danger_image: this.checkLicense(val.danger_image),
      }
    },
    checkLicense(val) {
      if (val) {
        if (typeof (val) == 'string') {
          return [val]
        } else {
          return val
        }
      } else {
        return []
      }
    },
    async bindWechat() {
      let res = await show_bind_wechat()
      if (res.data.code == 10000) {
        const qrcode_url = res.data.data.qrcode_url
        const width = 400;
        const height = 500;
        const left = (screen.width - width) / 3;
        const top = (screen.height - height) / 3;

        const loginWindow = window.open(
            qrcode_url, // 确保这个路由指向你的登录页面
            'LoginWindow',
            `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
        );

        // 检查弹窗是否被浏览器阻止
        if (!loginWindow) {
          this.$message.error('弹窗被浏览器阻止，请允许弹窗后重试')
          return
        }

        // 定义消息处理函数
        const handleMessage = (event) => {
          // 允许所有来源的消息用于调试（生产环境应限制具体域名）
          const allowedOrigin = event.origin;
          if (event.origin !== allowedOrigin) {
            console.log('来源不匹配，拒绝消息');
            return;
          }

          if (event.data.type === 'WECHAT_BIND') {
            console.log('收到微信登录重定向消息:', event.data);
            const data = event.data.data;

            // 收到消息后移除事件监听器
            window.removeEventListener('message', handleMessage);

            // 关闭弹窗
            if (loginWindow && !loginWindow.closed) {
              loginWindow.close();
            }

            bind_wechat(data).then(res => {
              if (res.data.code === 10000) {
                this.$message.success(res.data.message);
                this.$store.dispatch('GET_USER_INFO')
              } else {
                this.$message.error(res.data.message || '绑定失败');
              }
            }).catch(error => {
              console.error('绑定请求失败:', error);
              this.$message.error('绑定请求失败');
            })
          }
        };
        // 绑定 message 事件
        window.addEventListener('message', handleMessage);
        // 监听弹窗是否关闭
        const checkPopup = setInterval(() => {
          if (loginWindow.closed) {
            clearInterval(checkPopup);
            // 清理消息监听器
            window.removeEventListener('message', handleMessage);
            console.log('登录窗口已关闭');
          }
        }, 500);


      }
    },
    handleSubmit() {
      // 修改用户信
      this.$refs["formRules"].validate((valid) => {
        if (valid) {
          if (this.userInfo.is_check !== 1) {
            this.editInfoFun();
          } else {
            this.noChangeStatus()
          }
        } else {
          return false;
        }
      });
    },
    noChangeStatus() {
      let params = {
        avatar: this.userform.avatar[0],
        nickname: this.userform.nickname,
        role: this.userform.role,
        email: this.userform.email,
        district: this.userform.district,
        tax_type: this.userform.tax_type,
        company_code: this.userform.company_code,
        other: this.userform.other,
        danger_image: this.userform.danger_image,
      };
      updateUserInfonew(params).then((res) => {
            if (res.data.code == 10000) {
              this.$message.success({
                message: res.data.message,
                duration: 3000,
                offset: 200,
              });
              this.$store.dispatch("GET_USER_INFO");
              this.$router.push("/user/user-center");
            } else {
              this.$message.error({
                message: res.data.message,
                duration: 2000,
                offset: 200,
              });
            }
          }
      )
    },
    editInfoFun() {
      let params = {
        avatar: this.userform.avatar[0],
        nickname: this.userform.nickname,
        email: this.userform.email,
        realname: this.userform.realname,
        company: this.userform.company,
        tax_type: this.userform.tax_type,
        license: this.userform.license[0],
        other: this.userform.other,
        role: this.userform.role,
        district: this.userform.district,
        company_code: this.userform.company_code,
        danger_image: this.userform.danger_image,
      };
      editInfo(params).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: res.data.message,
            duration: 3000,
            offset: 200,
          });
          this.$store.dispatch("GET_USER_INFO");
          this.$router.push("/user/user-center");
        } else {
          this.$message.error({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
        }
      });
    },
    handleLicense(val) {
      this.userform.license = val;
    },
    handleDangerImage(val) {
      this.userform.danger_image = val;
    },
    handleOther(val) {
      this.userform.other = val;
    },
    handleAvatar(val) {
      this.userform.avatar = val;
    },

    // 校验密码
    checkPassword(rule, value, callback) {
      if (value !== this.passwordForm.password) {
        callback(new Error("两次密码不一致"));
      }
      callback();
    },
    // 修改密码
    editPasswordSubmit() {
      this.$refs["passwordForm"].validate((valid) => {
        if (valid) {
          editPassword(this.passwordForm).then((res) => {
            if (res.data.code == 10000) {
              this.$message.success({
                message: res.data.message,
                duration: 2000,
                offset: 200,
              });
              this.$refs["passwordForm"].resetFields();
              setTimeout(() => {
                this.$utils.logout(this.$store, this.$router);
              }, 1000);
            } else {
              this.$message.error({
                message: res.data.message,
                duration: 2000,
                offset: 200,
              });
            }
          });
        }
      });
    },
    init() {
      getMyCustomerService().then((res) => {
        this.customerService = res.data.data;
      });
      // 获取区域选项
      getAreaOptions().then((res) => {
        this.areaOptions = res.data.data.map((item) => {
          return {
            value: item.id,
            label: item.name,
            children: item.children.map((item) => {
              return {
                value: item.id,
                label: item.name,
                children: item.children.map((item) => {
                  return {
                    value: item.id,
                    label: item.name,
                  };
                }),
              };
            }),
          };
        });
      });
    },
    // 复制文本
    copyText(text) {
      this.$utils.copyText(text, this);
    },
    // 关闭开票信息弹窗
    invoicingeAddClose(e) {
      this.invoicingeAddDialog = e || false;
    },
    // 添加开票信息
    invoicingeAdd() {
      this.invoicingeAddDialog = true;
      this.invoicingId = "";
    },
    // 获取开票信息
    getInvoice() {
      invoiceList().then((res) => {
        this.invoicingTable = res.data.data.data;
      });
    },

    // 编辑开票信息
    invoiceEdit(id) {
      this.invoicingId = id;
    },
    // 删除开票信息
    invoiceDel(id) {
      this.$confirm("确定删除该开票信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        invoiceDelete(id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
            this.getInvoice();
          } else {
            this.$message.error({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
          }
        });
      });
    },
    // 获取地址列表
    getAddress() {
      this.addressId = "";
      getUserAddress().then((res) => {
        this.addressList = res.data.data.data;
      });
    },
    // 关闭地址弹窗
    addressAddCloseDialog() {
      this.addressAddDialog = false;
    },

    // 删除地址
    addressDel(id) {
      this.$confirm("确定删除该地址吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        addressDelete(id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
            this.getAddress();
          } else {
            this.$message.error({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
          }
        });
      });
    },
    // 添加地址弹窗
    addressAdd() {
      this.addressAddDialog = true;
      this.addressId = "";
    },
    // 编辑地址
    editAddress(id) {
      this.addressId = id;
      console.log(this.addressId, "我执行了");

      this.addressAddDialog = true;
    },
    // 添加收款账户弹窗
    accountAdd() {
      this.accountAddDialog = true;
    },
    // 关闭收款账户弹窗
    accountAddClose() {
      this.accountAddDialog = false;
    },
    // 校验收款账户
    accountAddSubmit() {
      this.accountAddDialog = false;
      this.$refs["accountForm"].validate((valid) => {
        if (valid) {
          this.submitAccount();
        }
      });
    },
    // 提交收款账户
    async submitAccount() {
      let res;
      if (this.accountForm.id) {
        res = await accountUpdate(this.accountForm.id, this.accountForm);
      } else {
        res = await accountAdd(this.accountForm);
      }
      if (res.data.code == 10000) {
        this.$message.success({
          message: res.data.message,
          duration: 2000,
          offset: 200,
        });
        this.accountAddDialog = false;
        this.getAccount();
      }
    },
    // 获取收款账户列表
    getAccount() {
      accountList().then((res) => {
        this.accountList = res.data.data.data;
      });
    },
    // 编辑收款账户
    accountEdit(id) {
      accountDetail(id).then((res) => {
        this.accountForm = res.data.data;
      });
      this.accountAddDialog = true;
    },
    // 删除收款账户
    accountDel(id) {
      this.$confirm("确定删除该收款账户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        accountDelete(id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
            this.getAccount();
          } else {
            this.$message.error({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
          }
        });
      });
    },
    // 点击导航栏
    handleClick(tab, event) {
      this.activeName = tab;
    },
  },
};
</script>
<style scoped lang="scss">
.subtitle {
  margin-bottom: 20px;
  color: gray;
}

.body {
  margin-top: 20px;
}

.qrcode-show {
  text-align: center;

  img {
    width: 260px;
    height: 260px;
  }
}

.form-actions {
  display: flex;
  justify-content: space-around;
}

.content {

  // padding: 40px 0;
  ::v-deep .el-select {
    width: 100% !important;
  }

  /*去掉tabs底部的下划线*/
  ::v-deep .el-menu.el-menu--horizontal {
    border-bottom: none;
  }

  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
  }

  .add-box {
    padding: 0 40px;
  }

  .add-box-address {
    padding: 0 120px;
  }

  .add-box-account {
    padding: 0 120px;
  }

  .transaction {
    padding: 0 40px 40px;
    background: #ffffff;

    .title-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;
    }

    .table-box {
      border: 1px solid #d8d8d8;
    }
  }

  .edit-info {
    text-align: center;
    padding: 105px 0 0;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;

    .text-center {
      display: flex;
      justify-content: space-around;
    }
  }

  .user-info {
    padding: 60px 100px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;

    .user-title {
      display: flex;
      align-items: center;
      padding: 20px 0;
    }

    .gap-10 {
      gap: 10px;
    }

    .avatar-uploader {
      width: 320px;
      height: 220px;
      border: 1px dashed #d9d9d9;
      text-align: center;
      font-size: 60px;
      line-height: 220px;
      color: #f5f5f5;
    }

    .word-text {
      font-weight: 400;
      //font-size: 18px;
      color: #00112b;
      padding-top: 15px;
    }

    .margin-top {
      margin-top: 10px;
    }
  }
}

.model-mobile {
  -webkit-appearance: none;
  background-color: #FFF;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
  cursor: not-allowed;
}
</style>
